<div class="header">
  <h5>Documents du BC</h5>
  <mat-icon class="close-button" (click)="onModalCancel()" color="primary">cancel</mat-icon>
  <mat-divider></mat-divider>
</div>
<div class="mat-dialog-content">

  <div style="margin-top: 20px;">
    <div *ngFor="let document of data.documents;" class="myRow">
      <div class="doc">
        {{document.code}}
      </div>
      <div class="btn">
        <button mat-raised-button color="primary" (click)="onOpenDoc(document, data.idBc)">
          <mat-icon>get_app</mat-icon>
        </button>
      </div>
      <div class="btn">
        <button mat-raised-button color="primary" (click)="visualiseDoc(document, data.idBc)">
          <mat-icon>remove_red_eye</mat-icon>
        </button>
      </div>
      <div class="btn">
        <button mat-raised-button color="danger" (click)="onDeleteDoc(document, data.idBc)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
     
      
    </div>
  </div>
</div>